<template>
	<main class="w-full flex flex-col items-center min-h-96 mb-28 mt-10 px-2">
		<div class="text-3xl my-12 text-ihh-midnight-gray font-ihh-bold">404 Error - Page not found</div>
		<div class="text-rum-600">Uh oh, looks like the page you are looking for has moved or no longer exists.</div>

		<div class="w-full ml-10 mr-10">
			<div class="w-full flex flex-col items-center space-y-2">
				<div class="w-full max-w-96 mt-10">
					<input
						type="text"
						v-model="search.value"
						class="border rounded w-full border-ihh-form-label h-12 pl-2 text-rum-600"
						placeholder="Search the store..."
						@keyup.enter="handleSearch"
					/>
					<button @click="handleSearch" class="rounded bg-ihh-dark-salmon py-3 px-12 text-center text-ihh-midnight-gray w-full mt-2">Search</button>
				</div>
			</div>

			<Search :show="showSearch" @hide="handleHide" :searchValue="search.value" />
		</div>
	</main>
</template>

<script>
import Search from '../layout/search.vue'
export default {
	components: {
		Search,
	},
	data() {
		return {
			showSearch: false,
			searchTimeout: null,
			search: {
				activeIndex: 0,
				value: null,
				results: [],
				categories: [],
				loading: false,
			},
		}
	},
	methods: {
		handleSearch() {
			if (this.search.value) {
				this.showSearch = true
			}
		},
		handleHide() {
			this.search = {
				activeIndex: 0,
				value: null,
				results: [],
				categories: [],
				loading: false,
			}
			this.showSearch = false
		},
	},
}
</script>

<style></style>
